import { render, staticRenderFns } from "./AppointRecord.vue?vue&type=template&id=7bf3a9f5&scoped=true&"
import script from "./AppointRecord.vue?vue&type=script&lang=js&"
export * from "./AppointRecord.vue?vue&type=script&lang=js&"
import style0 from "./AppointRecord.vue?vue&type=style&index=0&id=7bf3a9f5&lang=less&scoped=true&"
import style1 from "./AppointRecord.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bf3a9f5",
  null
  
)

export default component.exports